import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { ServiceAdvisorBlockedSchedule } from "./api-interfaces/api-interface-advisor-blocked-schedule";
import { BlocksByAdvisorWorkshop } from "./api-interfaces/startEnd.interface";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APIServiceAdvisorBlockedSchedule{
    ApiURL: string = "";
    constructor(private http: HttpClient, private helperService: HelperService) {
        this.ApiURL = environment.ServiceAdvisorBlockedSchedule + 'ServiceAdvisorBlockedServices/';
      
    }
    
    public getSchedulesAndBlockedSchedules(advisorId:number): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.get(this.ApiURL + 'blockedDates/' + encodeURIComponent(advisorId),requestOptions);
 }
    public getByAdvisor(advisorId:number): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.get(this.ApiURL + 'byadvisor/' + encodeURIComponent(advisorId),requestOptions);
 }

 public getbyAdvisorandBrandId(advisorId: number,brandId?:number): Observable<any>{
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
        };
    if (brandId!== null && brandId!== undefined) {
        return this.http.get(this.ApiURL + 'AdvisorBlockedServiceByAdvisorIdBrand/'+encodeURIComponent(advisorId) +"/"+encodeURIComponent(brandId),requestOptions);
   } else {
       return this.http.get(this.ApiURL + 'AdvisorBlockedServiceByAdvisorIdBrand/'+encodeURIComponent(advisorId),requestOptions);
    }
}

public  getadvisorHistorialLocks(advisorId: number): Observable<any>{
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
        };
    return this.http.get(this.ApiURL + 'GetGroupBlockedByAdvisorId/'+encodeURIComponent(advisorId),requestOptions);

}
public GetBlocksByAdvisorId(advisorId: number, workshopId: number):Observable <any>{
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
        };
return this.http.get<any>(`${this.ApiURL}GetBlocksByAdvisorId/${advisorId}/${workshopId}`,requestOptions)
}

public deletClusterlocksettings(advisorId,initialdate,finaldate,initialhour,finalhour):  Observable<any>{
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
      };
    return this.http.delete(this.ApiURL+'DeleteAdvisorBlockedService/'+`${advisorId}/${initialdate}/${finaldate}/${initialhour}/${finalhour}`,requestOptions)
}
   
    public get(id: string): Observable<any>{ 
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        if (id !== null && id !== undefined) {
            return this.http.get(this.ApiURL + encodeURIComponent(id),requestOptions);
       } else {
           return this.http.get(this.ApiURL,requestOptions);
        } 
    }
    public post(dateInt:ServiceAdvisorBlockedSchedule): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };

        return this.http.post<any>(this.ApiURL, dateInt,requestOptions)

    }

    public put(dateInt:ServiceAdvisorBlockedSchedule): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };

        return this.http.put<any>(this.ApiURL, dateInt,requestOptions)

    }


    public delete(id: number):  Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };

        let apiURL = `${this.ApiURL}${id}`;
        return this.http.delete(apiURL,requestOptions)
    }

}